import { render, staticRenderFns } from "./TableMaterialOrdered.vue?vue&type=template&id=0b98928e&scoped=true"
import script from "./TableMaterialOrdered.vue?vue&type=script&lang=js"
export * from "./TableMaterialOrdered.vue?vue&type=script&lang=js"
import style0 from "./TableMaterialOrdered.vue?vue&type=style&index=0&id=0b98928e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98928e",
  null
  
)

export default component.exports